import { PortTypes } from "../../constant"

export const InletPortStrokeColor = '#3F993F'
export const OutletPortStrokeColor = '#31d0c6'

const portAttrs = {
  circle: {
    r: 5,
    magnet: true,
    stroke: OutletPortStrokeColor,
    strokeWidth: 2,
    fill: '#fff',
    visibility: 'hidden'
  },
}
export const nodePortGroups = {
  [PortTypes.SvgNozzlePort]: {
    position: {
      name: PortTypes.SvgNozzlePort
    },
    attrs: portAttrs,
  },
  [PortTypes.NozzlePort]: {
    position: {
      name: PortTypes.NozzlePort
    },
    zIndex: 100,
    attrs: portAttrs,
  },
  [PortTypes.LineJumpPort]: {
    position: {
      name: PortTypes.LineJumpPort
    },
    zIndex: 100,
    attrs: portAttrs,
  },
  [PortTypes.LinePort]: {
    position: {
      name: PortTypes.LineJumpPort
    },
    zIndex: 100,
    attrs: {
      circle: {
        r: 4,
        magnet: true,
        stroke: '#a84a32',
        strokeWidth: 2,
        fill: '#fff',
        visibility: 'hidden'
      }
    },
  },
}